import { MetaValue } from '@tff/types/tff/tfa-amend-ancillary-service';

interface AncillariesAccordion {
  type: string;
  ancillaries: MetaValue[];
}

/*
    assigns ssr objects corresponding type keys
  */

export const groupByType = (array: readonly MetaValue[]): AncillariesAccordion[] => {
  return array.reduce((acc, obj) => {
    const key = obj.type;
    if (!acc[key]) {
      acc[key] = { type: key, ancillaries: [] };
    }
    acc[key].ancillaries.push(obj);
    return acc;
  }, []);
};
